import { Component, Input, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ComPromoterCategoryModel } from 'src/app/model/com-promoter-category.model';
import { ComPromoterCategoryService } from 'src/app/services/com-promoter-category.service';

@Component({
  selector: 'app-modal-commission-promoter-category',
  templateUrl: './modal-commission-promoter-category.component.html',
  styleUrls: ['./modal-commission-promoter-category.component.css']
})
export class ModalCommissionPromoterCategoryComponent implements OnInit {
  @Input() entity: ComPromoterCategoryModel;
  @Input() mode: string;
  @Input() promoterCategories: any[] = [];
  @Input() employeeJobs: any[] = [];

  // estado pagina
  public viewStatus = 1;

  // mascaras
  public customPatterns = {
    'A': { pattern: new RegExp('[a-zA-Z0-9ñÑ ]') },
    'C': { pattern: new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]') },
    'N': { pattern: new RegExp('[0-9]') },
    'D': { pattern: new RegExp('[0-9.,]') }
  };

  ////////////////
  constructor(
    private comPromoterCategoryService: ComPromoterCategoryService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }
  ngOnInit() { }

  //
  toggleActive = () => this.entity.activeId = !this.entity.activeId;
  isValid = () => {
    let valid = true;
    let errors = [];

    // Convertir strings con comas a números
    const minAmount = this.parseNumber(this.entity.minCollectAmount);
    const maxAmount = this.parseNumber(this.entity.maxCollectAmount);

    if (!this.entity.promoterCategoryId) errors.push('Seleccione una categoría de promotor.');
    if (!this.entity.employeeJobId) errors.push('Seleccione un puesto de empleado.');
    if (minAmount === null || minAmount < 0)
      errors.push('El rango mínimo debe ser ≥ 0.');
    if (maxAmount !== null && maxAmount <= minAmount)
      errors.push('El rango máximo debe ser mayor al mínimo.');
    if (errors.length > 0) {
      valid = false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', { enableHtml: true });
    }
    return valid;
  }
  parseNumber = (value: any): number | null => {
    if (value === null || value === undefined || value === '') return null;
    if (typeof value === 'number') return value;
    // Remover comas y convertir a número
    const cleaned = String(value).replace(/,/g, '');
    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? null : parsed;
  }
  save = () => {
    if (this.isValid()) {
      // mostrar spinner
      this.viewStatus = 0;
      // convertir strings a números antes de enviar
      this.entity.minCollectAmount = this.parseNumber(this.entity.minCollectAmount);
      this.entity.maxCollectAmount = this.parseNumber(this.entity.maxCollectAmount);
      // enviar informacion
      this.comPromoterCategoryService.save(this.entity)
        .pipe(
          tap((resp: any) => {
            if (resp && resp.codeHttpStatus === 200) {
              this.modalService.dismissAll('success');
              this.toastr.success('La comisión se guardó con éxito.');
            } else {
              this.viewStatus = 1;
              this.toastr.error(resp && resp.messageError ? resp.messageError : 'Ocurrió un error al intentar guardar la comisión.');
            }
          }),
          catchError((error: HttpErrorResponse) => {
            this.viewStatus = 1;
            const body = error && error.error;
            if (error && error.status === 409 && body && body.codeHttpStatus === 409) {
              // combinación categoría+puesto duplicada: mensaje real del backend, no genérico
              this.toastr.warning(body.messageError, '¡Atención!');
            } else {
              this.toastr.error((body && body.messageError) || 'No fue posible guardar la configuración.', '¡Atención!');
            }
            return of(null);
          })
        )
        .subscribe();
    }
  }
  close = () => this.modalService.dismissAll();
}
